<template>
    <header
        class="page-header page-header-dark bg-gradient-primary-to-secondary"
    >
        <div class="page-header-content pt-10">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6" data-aos="fade-up">
                        <h1 class="page-header-title">
                            Contabilidade agora é assim:
                        </h1>
                        <p class="page-header-text mb-5">
                            União da contabilidade com a tecnologia. Consultiva,
                            sem burocracia e simplificando processos.
                        </p>
                        <a
                            class="btn btn-teal btn-marketing rounded-pill lift lift-sm"
                            href="/cadastro"
                        >
                            Abrir empresa
                            <i class="fas fa-arrow-right ml-1"></i>
                        </a>
                        <a class="btn btn-link btn-marketing" href="/cadastro">
                            Trocar de contador
                        </a>
                    </div>
                    <div
                        class="col-lg-6 d-none d-lg-block"
                        data-aos="fade-up"
                        data-aos-delay="50"
                    >
                        <img
                            class="img-fluid"
                            src="/layouts/site/contabilidade/assets/img/drawkit/color/ilustração-header.svg"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="svg-border-rounded text-white">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 144.54 17.34"
                preserveAspectRatio="none"
                fill="currentColor"
            >
                <path
                    d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
                ></path>
            </svg>
        </div>
    </header>
</template>
<script>
export default {
    
}
</script>
